<article class="bg-white mt-6 px-4 lg:px-6 py-2.5">
    <div class="justify-between items-start mx-auto max-w-screen-xl">
        <h1 id="nav-laborkonzepte" class="text-center mb-8">Entwicklung neuer Laborkonzepte</h1>
        <p class="mx-32 mt-5 text-justify">
            <span>
            Im Rahmen des Projekts wird unser Angebot stätig mit neuen naturwissenschaftlichen Online-Laboren erweitert.
            Ideen und Vorschläge werden gerne entgegengenommen und auf ihre Umsetzbarkeit und Kosten geprüft.
            Zu beachten ist dabei, dass Online-Labore komplett ferngesteuert sind.
            Daher ist es essentiell darauf zu achten, dass alle Arbeitsschritte eines Experiments im Online-Labor auch automatisiert werden können.
            </span>
            <br/><br/>
            
            
        </p>

        <div class="flex justify-center">
            <div class="block p-6 rounded-lg shadow-lg bg-slate-200 max-w-sm my-6">
                  <h5 class="text-slate-900 text-xl leading-tight font-medium mb-2">Ansprechpartner</h5>
                  <p class="text-slate-700 text-base mb-4">
                    Christian Kreiter<br/>
                    Fachhochschule Kärnten<br/>
                    c.kreiter [at] fh-kaernten [punkt] at
                  </p>
            </div>
        </div>

    </div>
</article>
